/* VitaFresh: Links auf Gerichte öffnen den Quick-View der Kollektion statt der alten Schnellansicht des Themes
   (Pasci 18.10.2026, B4 der Code-Prüfung). Gilt für «Jetzt kaufen» bei «Der Küchenchef empfiehlt»
   (sections/vf-gericht-empfehlungen.liquid) und Gericht-Links in Blog-Beiträgen (sections/main-article.liquid).
   Markup: <a href="/products/<handle>" data-vf-quick>. Der Quick-View kommt aus assets/vf-gericht-karte.js
   (window.vfGerichtQuick); fehlt es auf der Seite (Blog), lädt dieses Skript es beim ersten Klick nach, samt
   vf-gericht-karte.css (Adressen aus data-css/data-js am eigenen <script>). Scheitert etwas, öffnet der Link
   normal die Gerichtseite. Ohne JS bleibt es ein Link.
   Grösse (Pasci 18.10.2026): Ist das Gericht ein Favorit mit gemerkter Grösse, öffnet der Quick-View damit
   (window.vfFavoriten.karten aus assets/vf-favoriten.js, einmal je Seite, höchstens FAV_WARTEN_MS warten), sonst
   wählt die Section Mittel vor (sections/vf-gericht-quick.liquid). Trägt der Link data-vf-quick-variante (Varianten-ID, z. B. die
   gewählte Grösse im Steckbrief der Erklärseite, assets/vf-einordnung.js), gilt diese statt der gemerkten (29.10.2026). */
(function (root) {
  "use strict";
  var doc = root.document;
  if (!doc || root.vfQuickOeffnen) return;
  root.vfQuickOeffnen = true;
  var skript = doc.currentScript;
  var CSS = skript && skript.getAttribute("data-css");
  var JS = skript && skript.getAttribute("data-js");
  var laden = null;
  var FAV_WARTEN_MS = 1200;
  var favKarten = null;

  /* Varianten-ID der gemerkten Grösse eines Favoriten, sonst null. Nie ein Grund, den Quick-View aufzuhalten. */
  function gemerkteVariante(pfad) {
    var F = root.vfFavoriten;
    if (!F || !F.eingeloggt || typeof F.karten !== "function") return Promise.resolve(null);
    if (!favKarten) favKarten = Promise.resolve().then(function () { return F.karten(); })
      .then(function (d) { return d && d.status === "ok" ? d.items : []; }, function () { return []; });
    var suche = favKarten.then(function (items) {
      var handle = decodeURIComponent(pfad.split("/")[2] || "");
      var item = null;
      for (var i = 0; i < items.length; i++) if (items[i] && items[i].h === handle) item = items[i];
      if (!item || !item.groesse || !Array.isArray(item.varianten)) return null;
      for (var j = 0; j < item.varianten.length; j++) if (item.varianten[j].size === item.groesse) return item.varianten[j].id;
      return null;
    });
    /* Antwortet das Portal nicht, wartet nur der erste Klick: danach gilt die Liste als leer (Mittel). */
    var uhr;
    var frist = new Promise(function (fertig) { uhr = setTimeout(function () { favKarten = Promise.resolve([]); fertig(null); }, FAV_WARTEN_MS); });
    return Promise.race([suche, frist]).then(function (id) { clearTimeout(uhr); return id; }, function () { clearTimeout(uhr); return null; });
  }

  /* Nur eigene Gerichtseiten: /products/<handle>, ohne Unterpfad; Query (z. B. Empfehlungs-Parameter) fällt weg */
  function pfadVon(a) {
    try {
      var u = new URL(a.getAttribute("href"), root.location.href);
      if (u.origin !== root.location.origin) return null;
      return /^\/products\/[^\/?#]+$/.test(u.pathname) ? u.pathname : null;
    } catch (e) { return null; }
  }

  function nachladen() {
    if (typeof root.vfGerichtQuick === "function") return Promise.resolve();
    if (laden) return laden;
    laden = new Promise(function (fertig, fehler) {
      if (!JS) { fehler(new Error("kein Skript")); return; }
      /* Erst öffnen, wenn auch das CSS da ist: sonst misst der Quick-View ohne Stil (Text kürzen, «Mehr lesen»).
         Scheitert nur das CSS, trotzdem öffnen. */
      var css = Promise.resolve();
      if (CSS && !doc.querySelector('link[href="' + CSS + '"]')) {
        css = new Promise(function (ok) {
          var l = doc.createElement("link");
          l.rel = "stylesheet"; l.href = CSS;
          l.onload = ok; l.onerror = ok;
          doc.head.appendChild(l);
        });
      }
      var js = new Promise(function (ok, nein) {
        var s = doc.createElement("script");
        s.src = JS;
        s.onload = function () { typeof root.vfGerichtQuick === "function" ? ok() : nein(new Error("fehlt")); };
        s.onerror = nein;
        doc.head.appendChild(s);
      });
      Promise.all([css, js]).then(function () { fertig(); }, fehler);
    });
    laden.catch(function () { laden = null; });
    return laden;
  }

  doc.addEventListener("click", function (ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target && ev.target.closest ? ev.target.closest("a[data-vf-quick]") : null;
    if (!a) return;
    var pfad = pfadVon(a);
    if (!pfad) return;
    ev.preventDefault();
    a.setAttribute("aria-busy", "true");
    var vorgabe = a.getAttribute("data-vf-quick-variante");
    Promise.all([nachladen(), /^\d+$/.test(vorgabe || "") ? vorgabe : gemerkteVariante(pfad)]).then(function (r) {
      a.removeAttribute("aria-busy");
      root.vfGerichtQuick(pfad, r[1], a);
    }, function () {
      a.removeAttribute("aria-busy");
      root.location.assign(a.href);
    });
  });
})(typeof window !== "undefined" ? window : globalThis);
